export const badRequestMessage = 'Ошибка обработки запроса, повторите позже.';

// Строки в массивах так как в разметке перенос строки и они лежат в разных Typography
export const mainNameWithYear = [
  `© ${new Date().getFullYear()}  МедиЛавия. Все права защищены`, 
  'для детей и взрослых'
];

export const mainNameWithoutYear = [
  'Клиника комплексных решений',
  'для детей и взрослых'
]

export const footerText = {
  highlighted: 'Личный кабинет ',
  msg1: '«МедиЛавия»',
  msg2: `© ${new Date().getFullYear()} МедиЛавия. Все права защищены.`
}
